import { ecsApi } from '@services';
import { FileResponse } from './files.types';

export const filesApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        uploadFile: builder.mutation<FileResponse, FormData>({
            query: (file) => ({
                url: '/files/upload',
                method: 'POST',
                body: file
            })
        })
    })
});

export const { useUploadFileMutation } = filesApi;
